import React from 'react';
import styled from 'styled-components';
import LinearProgress from '@material-ui/core/LinearProgress';

const Loading = () => {
    const StyledLoader = styled(LinearProgress)`
      margin: ${props => props.theme.space[10]} 0;
    `;

    return (
        <StyledLoader />
    );
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js